import * as yup from "yup";

export const AuthSchema = yup.object().shape({
  email: yup.string().email('Введите верный адрес электронной почты'),
  password: yup.string().max(20, 'Максимальная длина пароли 20 символов').min(5, 'Минимальная длина пароля 6 символов')
})
